__turbopack_context__.v({
  "header": "mantineDrawer-module-scss-module__tzHt3q__header",
});
